<section fxLayout="column" fxFlexAlign="stretch"> 
    <table>
        <tr>
           <td style="vertical-align: top;width: 30%;">
               <img src="../../assets/afisa3.jpg" width="100%" />
           </td> 
           <td style="vertical-align: top;padding-left: 12px;">
            <div>
                <h2>ΓΕΝΙΚΕΣ ΠΛΗΡΟΦΟΡΙΕΣ</h2>
                <br/>
                <h3>ΤΟΠΟΣ ΚΑΙ ΧΡΟΝΟΣ ΔΙΕΞΑΓΩΓΗΣ ΣΥΝΕΔΡΙΟΥ</h3>
                <div>Ξενοδοχείο DIVANI CARAVEL, Αθήνα, 3 - 5 Φεβρουαρίου 2023.</div>
                <br/>
                <h3>ΣΥΝΕΧΙΖΟΜΕΝΗ ΙΑΤΡΙΚΗ ΕΚΠΑΙΔΕΥΣΗ</h3>
                <div>Στους συμμετέχοντες θα χορηγηθούν 22 μόρια Συνεχιζόμενης Ιατρικής Εκπαίδευσης
                    (CME Credits) από τον Πανελλήνιο Ιατρικό Σύλλογο.</div>
                <br/>
                <h3>ΓΛΩΣΣΑ ΣΥΝΕΔΡΙΟΥ</h3>
                <div>Η επίσημη γλώσσα του Συνεδρίου είναι η Ελληνική.</div>
                <br/>
                <h3>ΤΕΧΝΙΚΟΣ ΕΞΟΠΛΙΣΜΟΣ</h3>
                <div>Η συνεδριακή αίθουσα θα είναι εξοπλισμένη με slide & overhead projectors καθώς και
                    για παρουσιάσεις μέσω power point.</div>
                <br/>
                <h3>ΕΜΠΟΡΙΚΗ ΕΚΘΕΣΗ</h3>
                <div>Σε όλη την διάρκεια του Συνεδρίου θα λειτουργεί εμπορική έκθεση Φαρμακευτικών
                    και Ιατρικών Ειδών στο φουαγιέ της αίθουσας ΜΑΚΕΔΟΝΙΑ του ξενοδοχείου DIVANI
                    CARAVEL.</div>
                <br/>
                <h3>ΒΡΑΒΕΥΣΗ ΕΡΓΑΣΙΩΝ</h3>
                <div>Θα βραβευθούν οι έξι (6) καλύτερες ανακοινώσεις.</div>
                <br/>
                <h3>ΣΥΜΜΕΤΟΧΗ ΜΕ ΦΥΣΙΚΗ ΠΑΡΟΥΣΙΑ</h3>
                
                <br/>
                <h3>ΕΓΓΡΑΦΕΣ - Συμμετοχή είτε με Φυσική Παρουσία είτε Διαδικτυακά</h3>
                <div>ΔΕΝ ΥΠΑΡΧΕΙ ΚΟΣΤΟΣ ΕΓΓΡΑΦΗΣ.</div>
                <br/>
                <p>Για την παρακολούθηση των εργασιών του συνεδρίου οι Σύνεδροι είναι απαραίτητο
                    να φέρουν την κονκάρδα εγγραφής που χορηγείται από τη γραμματεία on site και
                    παρακαλούνται να τη φέρουν καθ όλη τη διάρκεια του Συνεδρίου. Στην κονκάρδα
                    εγγραφής θα υπάρχει γραμμωτός κώδικας (barcode) και θα σκανάρεται σε ειδικό
                    μηχάνημα κάθε φορά κατά την είσοδο και έξοδό του από τις συνεδριακές αίθουσες.</p>
                <p>Οι εγγεγραμμένοι σύνεδροι που έχουν συμπληρώσει το 60% των συνολικών ωρών του
                    προγράμματος (είτε με Φυσική Παρουσία-είτε Διαδικτυακά) θα λάβουν ηλεκτρονικές
                    οδηγίες για τη συμπλήρωση του Δελτίου Αξιολόγησης και θα παραλάβουν το
                    Πιστοποιητικό Παρακολούθησης στην ηλεκτρονική διεύθυνση (e-mail) που έχουν
                    δηλώσει κατά την εγγραφή τους, λίγες ημέρες μετά τη λήξη του συνεδρίου.</p>
                <p>Απαραίτητη προϋπόθεση για να παρακολουθήσετε το συνέδριο διαδυκτιακά η ηλεκτρονική
                    εγγραφή σας στην ιστοσελίδα του συνεδρίου.</p>
                <p><a href="https://emeka2023.letscongress.eu/home">https://emeka2023.letscongress.eu/home</a></p>
                <p>Με την ηλεκτρονική εγγραφή σας θα λαμβάνετε την επιβεβαίωσή της.</p>
                
                <h3>ΦΟΙΤΗΤΕΣ ΙΑΤΡΙΚΗΣ & ΕΠΙΣΤΗΜΩΝ ΥΓΕΙΑΣ • ΜΕΤΑΠΤΥΧΙΑΚΟΙ ΦΟΙΤΗΤΕΣ • ΠΤΥΧΙΟΥΧΟΙ ΙΑΤΡΙΚΗΣ</h3>
                <div>Σημειώνεται ότι επειδή ανάμεσα στους στόχους της ΕΜΕΚΑ είναι και η προσέγγιση
                    των νέων επιστημόνων, πέραν του πιστοποιητικού παρακολούθησης, όσοι εκ των
                    συμμετεχόντων ΦΟΙΤΗΤΩΝ ΙΑΤΡΙΚΗΣ & ΕΠΙΣΤΗΜΩΝ ΥΓΕΙΑΣ, ΜΕΤΑΠΤΥΧΙΑΚΟΙ
                    ΦΟΙΤΗΤΕΣ, ΠΤΥΧΙΟΥΧΟΙ ΙΑΤΡΙΚΗΣ παρακολουθήσουν το πρόγραμμα του συνεδρίου Θα
                    λάβουν ένα USB με τις τρέχουσες κατευθυντήριες οδηγίες της Ευρωπαϊκής Καρδιολογικής
                    Εταιρείας σε μορφή εύχρηστη για το αγροτικό ιατρείο ή τα εξωτερικά ιατρεία.</div>
                <div>Οι 3 φοιτητές που έχουν το μεγαλύτερο χρόνο παρακολούθησης του συνεδρίου,
                    θα παραλάβουν από ένα βιβλίο Καρδιακής Ανεπάρκειας.</div>
                <div>Απαραίτητη προϋπόθεση να δηλώνουν την ιδιότητα τους (φοιτητής ιατρικής) κατά την
                    εγγραφής τους.</div>
                <br/>
                <h3>Ειδικευόμενοι ΠΑΘΟΛΟΓΙΑΣ - ΚΑΡΔΙΟΛΟΓΙΑΣ</h3>
                <div>Οι 3 ΕΙΔΙΚΕΥΟΜΕΝΟΙ ΠΑΘΟΛΟΓΙΑΣ-ΚΑΡΔΙΟΛΟΓΙΑΣ που έχουν το μεγαλύτερο χρόνο
                    παρακολούθησης του συνεδρίου, θα παραλάβουν από ένα βιβλίο Καρδιακής Ανεπάρκειας.
                    Απαραίτητη προϋπόθεση να δηλώνουν την ιδιότητα τους (ειδικευόμενος παθολογίας-
                    καρδιολογίας) κατά την εγγραφής τους.</div>
                <br/>
                <h3>Μετεκπαιδευτικό Σεμινάριο Προχωρημένης Καρδιακής Ανεπάρκειας
                    και Μυοκαρδιοπαθειών σε συνεργασία με την ΟΕ
                    της Καρδιακής Ανεπάρκειας της ΕΚΕ</h3>
                <div>Όσοι παρακολουθήσουν τα ακόλουθα σεμινάρια θα λάβουν Μετεκπαιδευτικό Σεμινάριο
                    Προχωρημένης Καρδιακής Ανεπάρκειας και Μυοκαρδιοπαθειών, επιπλέον του
                    Πιστοποιητικού Παρακολούθησης του συνεδρίου</div>
                <br/>
                <div><b>α) Σάββατο 04/02/23, Ώρα 09.00-10.30 Αίθουσα ΜΥΚΗΝΕΣ</b></div>
                <div style="margin-left:22px">Συσκευές μηχανικής υποβοήθησης της κυκλοφορίας</div>
                <br/>
                <div><b>β) Σάββατο 04/02/23, Ώρα 11.15-12.30 Αίθουσα ΜΥΚΗΝΕΣ</b></div>
                <div style="margin-left:22px">Συνεδρία Νίκου Πρωτονοτάριου. Μυοκαρδιοπάθειες 2022</div>
            </div>
           </td>
        </tr>
    </table>
</section>
